import { orderFeatureApi } from "@src/features/order/redux";
import { ICreateMissionRequest, IGetTerrainAwareRequest, IUpdateMissionRequest } from "./types";
import { OrderMissionEntity } from "@src/core/features";
import { WaypointEntity } from "@src/core/entities";

export const upsertMissionApi = orderFeatureApi.injectEndpoints({
  endpoints: (builder) => ({
    createMission: builder.mutation<OrderMissionEntity, ICreateMissionRequest>({
      query: ({ orderId, ...data }) => ({
        url: `/api/v2/orders/${orderId}/missions`,
        method: 'POST',
        data
      }),
      invalidatesTags: ['OrderDetails'],
    }),
    updateMission: builder.mutation<OrderMissionEntity, IUpdateMissionRequest>({
      query: (data) => ({
        url: `/api/v2/orders/missions/${data.missionId}`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['OrderDetails'],
    }),
    getTerrainAware: builder.mutation<WaypointEntity[], IGetTerrainAwareRequest[]>({
      query: (data) => ({
        url: '/api/v1/orders/waypoints/terrain-aware',
        method: 'POST',
        data,
      }),
    }),
  })
});

export const { 
  useCreateMissionMutation, 
  useUpdateMissionMutation, 
  useGetTerrainAwareMutation,
} = upsertMissionApi;